import React, { Suspense, lazy } from "react";
import Spinner from "./ui/spinner";
import SEO from "../seo/SEO";
import { SEO_PAGES, getBreadcrumbSchema, getJobPostingSchemas } from "../seo/seoConfig";

const CareersHero = lazy(() => import("./pages/for_Career/careers-hero"));
const WhyWorkWithUs = lazy(() => import("./pages/for_Career/why-work-with-us"));
const OpenPositions = lazy(() => import("./pages/for_Career/open-positions"));
const LifeAtPyCray = lazy(() => import("./pages/for_Career/life-at-pycray"));
const JoinUs = lazy(() => import("./pages/for_Career/join_us"));
const Footer = lazy(() => import("./footer"));

export const CareersPage = () => {
  const seo = SEO_PAGES.careers;
  return (
    <>
      <SEO
        {...seo}
        schemas={[
          getBreadcrumbSchema([
            { name: "Home", path: "/" },
            { name: "Careers", path: "/careers" },
          ]),
          ...getJobPostingSchemas(),
        ]}
      />
    <div id="career">
      <main className="flex flex-col">
        <Suspense fallback={<Spinner />}>
          <CareersHero />
        </Suspense>
        <Suspense fallback={<Spinner />}>
          <WhyWorkWithUs />
        </Suspense>
        <Suspense fallback={<Spinner />}>
          <OpenPositions />
        </Suspense>
        <Suspense fallback={<Spinner />}>
          <LifeAtPyCray />
        </Suspense>
        <Suspense fallback={<Spinner />}>
          <JoinUs />
        </Suspense>
        <Suspense fallback={<Spinner />}>
          <Footer />
        </Suspense>
      </main>
    </div>
    </>
  );
};
